<template>
  <PSRegion />
</template>

<script>
export default {
    data() {
        return {
        }
    }
}
</script>
